















































import { Component, Vue, Prop } from "vue-property-decorator";

import { moveSet } from "@/move-set";

@Component({
    name: "SettingItem",
    props: {
        settingName: String,
        status: Boolean,
    },
})
export default class SettingItem extends Vue {
    private toggle(): void {
        this.$emit("toggle");
    }
    private moveSet(ev: KeyboardEvent): void {
        moveSet(ev);
    }
}
